import React, { FC } from 'react';
import { TextInput, EnumDropdown, useFormContext } from 'framework/form';
import { EDITABLE_LIST_FIELD } from 'framework/list';
import { PROJECT_PROBABILITY_OPTIONS, RISK_TYPE_OPTIONS } from 'domain/shared/newProject';
import { compactDisabledInputSx } from 'domain/projects/newProject/shared/compactDisabledInputSx';
import PredecessorSection from './PredecessorSection';

const getTableCells = async (isEditMode: boolean) => {
  const disabled = !isEditMode;
  return [
    {
      type: EDITABLE_LIST_FIELD,
      source: 'alias',
      isEditor: true,
      component: TextInput,
      componentProps: { label: '', disabled: true },
      gridCellProps: { size: 0.5, sx: compactDisabledInputSx },
    },
    {
      type: EDITABLE_LIST_FIELD,
      source: 'title',
      isEditor: true,
      component: TextInput,
      componentProps: { label: 'Risk', disabled },
      gridCellProps: { size: 4 },
    },
    {
      type: EDITABLE_LIST_FIELD,
      source: 'type',
      isEditor: true,
      component: EnumDropdown,
      componentProps: { label: 'Type', options: RISK_TYPE_OPTIONS, disabled },
      gridCellProps: { size: 2.5 },
    },
    {
      type: EDITABLE_LIST_FIELD,
      source: 'probability',
      isEditor: true,
      component: EnumDropdown,
      componentProps: { label: 'Probability', options: PROJECT_PROBABILITY_OPTIONS, disabled },
      gridCellProps: { size: 2.5 },
    },
    {
      type: EDITABLE_LIST_FIELD,
      source: 'severity',
      isEditor: true,
      component: EnumDropdown,
      componentProps: { label: 'Severity', options: PROJECT_PROBABILITY_OPTIONS, disabled },
      gridCellProps: { size: 2 },
    },
  ];
};

const PredecessorRisks: FC = () => {
  const { data } = useFormContext();
  const risks = data?.risks ?? [];

  return (
    <PredecessorSection
      title="Risks"
      listSource="risks"
      isEmpty={risks.length === 0}
      note="During the risk transfer, the mitigation strategies associated with the risk will also be transferred. The risk owner will need to be assigned after the transfer."
      getTableCells={getTableCells}
    />
  );
};

export default PredecessorRisks;
